import { useMutation, useQueryClient } from "@tanstack/react-query";

import { findAppsQueryKeyFactory } from "app/pages/sales-intelligence/pages/find-apps/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { AppsColumnConfigDto, AppsColumnSelectionRequestDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

const useUpdateColumnSelection = (appSourceType: AppsSourceType) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn(dto: AppsColumnSelectionRequestDto) {
            return salesApiService.findApps[appSourceType].saveColumnSelection(dto);
        },
        onSuccess(_data, dto: AppsColumnSelectionRequestDto) {
            queryClient.setQueryData(
                findAppsQueryKeyFactory.columnConfig(appSourceType),
                (prevData: AppsColumnConfigDto) => ({ ...prevData, selected: dto.columns }),
            );

            void queryClient.invalidateQueries({
                queryKey: findAppsQueryKeyFactory.appData(appSourceType),
            });
        },
    });
};

export default useUpdateColumnSelection;
